import { ProcesSteps } from 'typings';

const phases: ProcesSteps[] = [
  'begrijpen',
  'ontdekken',
  'ontwerpen',
  'maken',
  'delen',
  'vertrekpunt',
  'eindpunt',
];

export const getCorrectPhase = (processId: number) => phases[processId];
